module.exports = __webpack_public_path__ + "assets/lessons/en/lesson5/modals/lesson_5_12_g.pdf";